import * as ko from 'knockout';
import type { IInjectorModule } from '@paperbits/common/injection';

import '@paperbits/core/ko/bindingHandlers/bindingHandlers.component';
import '@paperbits/core/ko/bindingHandlers/bindingHandlers.hyperlink';
// import { StyledBindingHandler } from '@paperbits/styles/ko/bindingHandlers/bindingHandlers.styled';
import { StyledBindingHandler } from './bindingHandlers/emptyBindingHandler.styled';
import './bindingHandlers/bindingHandlers.datePicker';
import './bindingHandlers/bindingHandlers.quote';

export class KoRuntimeModule implements IInjectorModule {
    public register(): void {
        ko.virtualElements.allowedBindings['widget'] = true;
        ko.virtualElements.allowedBindings['component'] = true;  
        ko.virtualElements.allowedBindings['quote'] = true;
        new StyledBindingHandler();
    }
}